/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

class Facebook extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render = () => (
    <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" className={this.props.className}>
      <title>Facebook Icon</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Social-Icon-Set" fill="#414f60">
          <g id="Group-2">
            <g id="Facebook-20x20">
              <path d="M20,18.8962436 C20,19.5058702 19.5058702,20.0005448 18.8962436,20.0005448 L13.7996786,20.0005448 L13.7996786,12.2551824 L16.3994443,12.2551824 L16.7889733,9.23701343 L13.7996786,9.23701343 L13.7996786,7.30952576 C13.7996786,6.43567323 14.0426575,5.84021138 15.2956879,5.84021138 L16.8941189,5.83966658 L16.8941189,3.13965841 C16.6173626,3.10315709 15.6688731,3.02089292 14.5651167,3.02089292 C12.2606303,3.02089292 10.6829016,4.42755577 10.6829016,7.01097764 L10.6829016,9.23701343 L8.07659829,9.23701343 L8.07659829,12.2551824 L10.6829016,12.2551824 L10.6829016,20.0005448 L1.10375637,20.0005448 C0.494129825,20.0005448 0,19.5058702 0,18.8962436 L0,1.10430116 C0,0.494129825 0.494129825,0 1.10375637,0 L18.8962436,0 C19.5058702,0 20,0.494129825 20,1.10430116 L20,18.8962436" />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default Facebook;
